import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');
const saveAs = require('file-saver');

import { IGlob } from '../ts/Glob';
import { config } from '../ts/config';
import * as widgetDispatcher from '../ts/widgetDispatcher';
import { IMenuItemFlags, WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { WidgetData } from '../../../_common/platform/ts/WidgetData';
import * as Globalization from '../../../_common/platform/ts/Globalization';

import * as reactGlobalClick from '../../../_common/platform/ts/reactGlobalClick';
import * as appTheme from '../../../_common/platform/ts/appTheme';
import * as permissions from '../../../_common/platform/ts/permissions';
import { Constants } from '../../../_common/platform/ts/Constants';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';
// DB
import {
    Header as ConfigFieldSelectComponent_Header,
    Main as ConfigFieldSelectComponent_Main
} from './ConfigFieldSelectComponent';

import { PdfParamDialog } from './PdfParamDialog';

import GlobalState from '../../../_common/platform/ts/globalStates/GlobalState';
import printContent, { IPDFOptions } from '../../../_common/platform/ts/printContent';
import { IActionType } from '../../../_common/platform/ts/printContentUtils';
import { ThemeRenderer } from './ThemeRenderer';
import { LayoutGrid } from './layout/LayoutGrid';
import { ParameterField } from '../../../_common/platform/tsx/ParameterField';
import WidgetNotifications from './notifications/WidgetNotifications';
import ErrorBoundary from '../../../_common/platform/tsx/ErrorBoundary';
import { DisplayMode } from '../ts/stores/WorkspaceStore';
import LoadingPanel from './notifications/LoadingPanel';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import { themeVars } from '../ts/themes/themeConstants';
import WidgetHeader from './menus/WidgetHeader';
import { WIDGET_HIDING_SIZE } from './layout/gridLayout';
import { IWidgetLayout } from './layout/Interfaces';

import {
    IWidget,
    IWidgetOptions,
    IWidgetState,
    ILayoutData,
    IEdgeFlags,
    IComponentRef,
    IPageOrientation,
    IWidgetFieldElement
} from '../ts/Interfaces';

import {
    callBackendMethod,
    IBackendMethodConfiguratorValue,
    IBackendParameter
} from '../../../_common/platform/tsx/BackendMethodConfigurator';

import {
    ExportToExcelParameters,
    getCSVSeparator,
    IExportToExcelParametersOptions
} from '../tsx/exportImport/ExportToExcelParameters';

import {
    finalizeMenuHandler,
    getOnCreateLinkHandler,
    getMenuItemFlags,
    showWidgetMenu,
    getPlatformMenuItems,
    WidgetMenuButton,
    getMenuItems,
    getOnShowWidgetHelpHandler
} from './menus/WidgetMenu';

const LOCAL_MENU_OFFSET_TOP = 32;
const LOCAL_MENU_OFFSET_LEFT = 5;
const TOOLBAR_HEIGHT = 34;
const HEADER_BUTTON_WIDTH = 28;
const DEFAULT_HEADER_HEIGHT = LOCAL_MENU_OFFSET_TOP - LOCAL_MENU_OFFSET_LEFT;

export const DEFAULT_WIDGET_HEIGHT = 400;
export const DEFAULT_WIDGET_WIDTH = 400;

export interface IWidgetProperties {
    workspace: number;
    namespaces: { [namespave: string]: any };
    data: IWidget;
    theme: appTheme.IValuesCollection;
    _key: number;
    distractFree: boolean;
    tab: number;
    mainTab?: number; // Is used when state is split.
    hidden: boolean;
    isWorkspaceSaved: boolean;
    workspaceContextId: number;
    wUnits?: string; //LL: 12.12.23
    hUnits?: string; //LL: 12.12.23

    autoSize?: boolean;
    inlineMode?: boolean;
    printMode?: boolean;
    hideEdit?: boolean;
    showEdit?: boolean;
    layoutEdit?: boolean;
    style?: React.CSSProperties;
    displayMode?: DisplayMode;
    widgetState?: IWidgetState;
    forceHideHeader?: boolean;
    runTimeWidgetID?: number;
    globalState?: GlobalState;

    edgeFlags?: IEdgeFlags;

    options?: IWidgetOptions;
    layoutData?: ILayoutData;

    disableSizeMixin?: boolean;
    glob: IGlob;

    onLayoutModeChange?(layoutEdit: boolean): void;
    onToggleDocking?(): void;
}

interface IState {
    widgetData: WidgetData;
    loading: boolean;
    error: boolean;
    runTimeWidgetID: number;
    //icon: string;
    //tabBackColor: string;
    //loadingImage: boolean;
}

let runTimeWidgetID: number = 0;

export function getRunTimeWidgetID() {
    return runTimeWidgetID++;
}

export class Widget extends React.Component<IWidgetProperties, IState> {
    static defaultProps = {
        edgeFlags: {
            top: true,
            right: true,
            bottom: true,
            left: true
        }
    };

    private initStarted = false;
    private initialized = false;
    private widgetIsUnmounted = false;
    private componentRef: IComponentRef = null;
    private globalClickMenuIndex = -1;
    private globalClickLayoutIndex = -1;
    private clipboard = null;
    //private containersNum: number = null;
    private pdfLoading: boolean = false;
    private dispatcherIndex: number;
    private savedLayoutData: ILayoutData;

    private references: {
        containers: { [index: number]: HTMLDivElement };
        widgetheader?: HTMLDivElement;
        container?: HTMLDivElement;
        widgetToolbar?: HTMLDivElement;
    } = {
        containers: {}
    };

    constructor(props) {
        super(props);

        let runTimeWidgetID = this.props.options?.runTimeWidgetID;

        if (runTimeWidgetID == null) {
            runTimeWidgetID = getRunTimeWidgetID();
        }

        this.savedLayoutData = $.extend(true, {}, this.props.layoutData);

        const widgetData = WidgetData.getFromObj(this.props.data, this.props.glob, false);
        const state: IState = {
            widgetData: widgetData,
            loading: false,
            error: false,
            runTimeWidgetID: runTimeWidgetID
            //icon: data.widgetData.icon,
            //tabBackColor: data.widgetData.tabBackColor,
            //loadingImage: false,
        };

        this.state = state;
    }

    getWidgetValues = () => {
        return this.state.widgetData.values[this.props.data.type];
    };

    getCotainersNum = () => {
        // VR: When User has changed TYPE in CONFIG, this is WRONG, because OLD!!
        // if (this.containersNum != null) {
        //     return this.containersNum;
        // }
        const widget = WidgetBase.getConstructorByName(this.props.data.type);

        //return (this.containersNum = widget?.getContainersNum(this.props.data) || 1);
        return widget?.getContainersNum(this.props.data) ?? 1;
    };

    getLayout = (value: IWidgetLayout): IWidgetLayout => {
        const data = this.props.data;
        const widget = WidgetBase.getConstructorByName(data.type);

        // try to return 'static' layout
        if (widget != null && typeof widget.getDefaultLayout === 'function') {
            const defaultLayout = widget.getDefaultLayout(this.getWidgetValues());

            if (defaultLayout != null && defaultLayout.layoutKind === 'static') {
                return defaultLayout;
            }
        }

        // try to return editable layout
        const containersNum = this.getCotainersNum();
        const elementsNum = (data != null && data.elements != null && data.elements.length) || 0;

        if (value != null && value.size.length > containersNum + elementsNum) {
            value.size = value.size.slice(0, containersNum + elementsNum);
            value.pos = value.pos.slice(0, containersNum + elementsNum);
        }

        if (value != null) {
            return value;
        }

        // otherwise, return default layout
        if (widget != null && typeof widget.getDefaultLayout === 'function') {
            const defaultLayout = widget.getDefaultLayout(this.getWidgetValues());

            if (defaultLayout != null) {
                return defaultLayout;
            }
        }

        const iterRange = _.range(containersNum);

        return {
            columns: [
                {
                    ratio: 1
                }
            ],

            rows: _.map(iterRange, () => {
                return {
                    ratio: 1
                };
            }),

            pos: _.map(iterRange, (i) => {
                return [i, 0];
            }),

            size: _.map(iterRange, () => {
                return [1, 1];
            })
        };
    };

    handleOnEditComponentChange = (widgetData: WidgetData) => {
        this.setState({
            widgetData: widgetData
        });
    };

    addFieldElements = (layoutElements: React.JSX.Element[]) => {
        if (this.props.data.elements == null || this.state.widgetData.widget == null) {
            return;
        }

        const containersNum = this.getCotainersNum();

        this.props.data.elements.forEach((obj: IWidgetFieldElement, index: number) => {
            layoutElements.push(
                <FieldElement
                    key={obj?.name + '-' + index}
                    workspace={this.props.workspace}
                    id={this.props.data.id ?? this.props.data.cid}
                    widgetData={this.state.widgetData}
                    obj={obj}
                    index={index}
                    containersNum={containersNum}
                    glob={this.props.glob}
                    onEditComponentChange={this.handleOnEditComponentChange}
                />
            );
        });
    };

    getTheme = (props?: IWidgetProperties, state?: IState) => {
        if (props == null) {
            props = this.props;
        }

        if (state == null) {
            state = this.state;
        }

        const values = state.widgetData.values[props.data.type];
        const widgetTheme = values && values.theme;

        return appTheme.extend({}, props.theme, widgetTheme, widgetTheme && widgetTheme._custom);
    };

    getContainer = () => {
        return this.references.containers[0];
    };

    getOptions = (type: string) => {
        const containersNum = this.getCotainersNum();
        const theme = this.getTheme();

        let obj: IWidgetOptions = {
            container: this.getContainer(),
            containers: _.map(_.range(containersNum), (i) => {
                return this.references.containers[i];
            }),
            distractFree: this.props.distractFree,
            printMode: this.props.printMode,
            inlineMode: this.props.inlineMode,
            hideEdit: this.props.hideEdit,
            workspace: this.props.workspace,
            tab: this.props.tab,
            mainTab: this.props.mainTab,
            namespaces: this.props.namespaces,
            workspaceContextId: this.props.workspaceContextId,
            initialHidden: this.props.hidden,
            parentTheme: this.props.theme,
            theme: theme,
            displayMode: this.props.displayMode,
            themeContext: '#widget-' + this.props._key + '-' + this.props.workspace + '-' + this.props.tab,
            namespace: '_default',
            runTimeWidgetID: this.state.runTimeWidgetID,
            staticWidgetID: this.props.data.id ?? this.props.data.cid
        };

        if (this.props.options != null) {
            obj = _.extend(obj, this.props.options);
        }

        if (this.props.layoutData != null) {
            obj.layoutData = this.props.layoutData;
        }

        const constr = WidgetBase.getConstructorByName(type);

        if (constr != null) {
            obj.namespace = constr.namespace || '_default';
        }

        return obj;
    };

    getGlobalState = () => {
        if (this.props.globalState != null) {
            return this.props.globalState;
        }

        return GlobalState.getGlobalState(this.props.glob, this.props.tab);
    };

    postInit = (widget: IWidget, componentModule, printMode?: boolean, printLimit?: number) => {
        const widgetConstructor = WidgetBase.getConstructorByName(widget.type);

        if (widgetConstructor == null) {
            widgetDispatcher.widgetFailInit(this.props.workspaceContextId, this.props.data.id || this.props.data.cid);
            return;
        }

        const widgetID = widget.id || widget.cid;
        const options = this.getOptions(widget.type);

        options.printMode = printMode;
        options.printLimit = printLimit;

        widgetDispatcher.widgetInit(
            this.props.workspaceContextId,
            widgetID,
            () => {
                if (this.widgetIsUnmounted) {
                    console.log(`Widget '${widget.type}' is unmouinted after its post initialization is started.`);
                    return;
                }

                const normalizedData = WidgetData.normalizeData(widget, this.props.glob);
                const widgetParameters = normalizedData.values[normalizedData.type];
                const namespaceState = this.props.namespaces[options.namespace];

                let globalState = this.getGlobalState();

                if (globalState == null) {
                    globalState = GlobalState.createFactory(
                        this.props.glob,
                        options.workspace,
                        options.tab,
                        options.namespace,
                        namespaceState,
                        options.mainTab
                    );
                }

                this.props.glob.AppActions.widgetSetRole(
                    options.tab,
                    widgetID,
                    widgetParameters && widgetParameters.role
                );

                try {
                    componentModule.init(
                        options,
                        normalizedData,
                        this.props.glob,
                        namespaceState,
                        (componentRef: IComponentRef) => {
                            this.componentRef = componentRef;
                        },
                        globalState
                    );

                    this.initialized = true;

                    if (this.props.widgetState != null) {
                        this.props.glob.AppActions.widgetSetState(widgetID, this.props.widgetState);
                    }
                } catch (e) {
                    console.log('Error happened during widget init:', e);
                }
            },

            widgetConstructor.priority
        );
    };

    initWidget = (widget: IWidget, printMode?: boolean, printLimit?: number) => {
        const constr = WidgetBase.getConstructorByName(widget.type);

        if (constr == null) {
            widgetDispatcher.widgetFailInit(this.props.workspaceContextId, widget.id || widget.cid);
            return;
        }

        this.initStarted = true;

        constr
            .load()
            .done((componentModule) => {
                if (this.widgetIsUnmounted) {
                    console.log(`Widget '${widget.type}' is unmouinted after its initialization is started.`);
                    return;
                }

                const widgetData = WidgetData.getFromObj(widget, this.props.glob, false);

                this.setState({
                    widgetData: widgetData,
                    loading: false,
                    error: false
                });
                this.postInit(widget, componentModule, printMode, printLimit);
            })
            .fail(() => {
                widgetDispatcher.widgetFailInit(this.props.workspaceContextId, widget.id || widget.cid);

                if (this.widgetIsUnmounted) {
                    return;
                }

                this.setState({
                    loading: false,
                    error: true
                });
            });
    };

    destroyWidget = (widget: IWidget) => {
        const widgetID = widget.id || widget.cid;

        if (this.initialized == null) {
            widgetDispatcher.widgetFailDestroy(this.props.workspaceContextId, widgetID);
            return;
        }

        const constr = WidgetBase.getConstructorByName(widget.type);

        if (constr == null) {
            console.log("Widget type '" + widget.type + "' isn't registered in current build.");

            widgetDispatcher.widgetFailDestroy(this.props.workspaceContextId, widgetID);
            return;
        }

        const options = this.getOptions(widget.type);

        constr.load().done((componentModule) => {
            widgetDispatcher.widgetDestroy(
                this.props.workspaceContextId,
                widgetID,
                () => {
                    this.props.glob.AppActions.widgetUnsetRole(options.tab, widgetID);

                    try {
                        componentModule.destroy(
                            options,
                            WidgetData.normalizeData(widget, this.props.glob),
                            this.props.glob,
                            this.props.namespaces[options.namespace]
                        );

                        delete this.initialized;
                        delete this.componentRef;
                    } catch (e) {
                        console.log('Error happened during widget destroy:', e);
                    }
                },
                constr.priority
            );
        });
    };

    // See Issue 94822.
    // getWidgetHeaderHeight() can be called before Widget Header is drawn. In such a case the last height is used.
    private _lastWidgetHeaderHeight: number;

    getWidgetHeaderHeight = (parentHeight: number, theme: IValuesCollection) => {
        if (
            (parentHeight === WIDGET_HIDING_SIZE || !theme[themeVars.widget_AlwaysShowHeader]) &&
            this.props.displayMode !== 'widgets'
        ) {
            return 0;
        }

        const widgetHeader = this.references.widgetheader;

        let result: number;

        // See Issue 94460. If header is rotated, its height does not matter.
        if (widgetHeader != null && widgetHeader.className.indexOf('rotate') < 0) {
            result = widgetHeader.clientHeight;

            if (result == null || result === 0) {
                result = this._lastWidgetHeaderHeight;
            } else {
                this._lastWidgetHeaderHeight = result;
            }
        } else {
            this._lastWidgetHeaderHeight = undefined;
        }

        if (result == null) {
            result = DEFAULT_HEADER_HEIGHT;
        }

        return result;
    };

    performThemeUpdate = (prevProps: IWidgetProperties, prevState: IState) => {
        if (this.props.theme === prevProps.theme) {
            return;
        }

        const widgetType = this.props.data.type;
        const dataTheme = this.props.data.values[widgetType].theme;

        if (dataTheme != null) {
            this.props.data.values[widgetType].theme = appTheme.refillMapObj(dataTheme, this.props.glob);
        }

        const widgetValues = this.getWidgetValues();
        const widgetDataTheme = widgetValues.theme;

        if (widgetDataTheme != null) {
            widgetValues.theme = appTheme.refillMapObj(widgetDataTheme, this.props.glob);
        }

        const prevTheme = this.getTheme(prevProps, prevState);
        const curTheme = this.getTheme(this.props, this.state);

        if (!compareObjects(prevTheme, curTheme)) {
            this.props.glob.AppActions.widgetUpdateOptions(
                this.props.workspace,
                this.props.data && this.props.data.id,
                {
                    parentTheme: this.props.theme,
                    theme: curTheme
                }
            );
        }
    };

    componentDidMount() {
        if (!this.initialized) {
            this.setState({
                loading: true
            });
        }

        if (this.initStarted !== true && this.getContainer() != null) {
            this.initWidget(this.props.data, this.props.options?.printMode, this.props.options?.printLimit);
        }

        this.globalClickLayoutIndex = reactGlobalClick.register((e) => {
            this.disableLayoutEdit();
        }, 0);

        this.dispatcherIndex = this.props.glob.AppStore.dispatcher.register(this.handleOnAppStoreChange, this);
    }

    componentWillUnmount() {
        this.widgetIsUnmounted = true;
        this.destroyWidget(this.props.data);

        reactGlobalClick.unregister(this.globalClickMenuIndex);
        reactGlobalClick.unregister(this.globalClickLayoutIndex);

        if (this.clipboard != null) {
            this.clipboard.destroy();
        }

        this.props.glob.AppStore.dispatcher.unregister(this.dispatcherIndex);

        delete this.globalClickMenuIndex;
        delete this.globalClickLayoutIndex;
        //delete this.containersNum;
    }

    componentWillUpdate(nextProps: IWidgetProperties, nextState: IState) {
        // If widget type chaged during udate (on edit or paste), destroy module of previous type.
        if (this.props.data.type !== nextProps.data.type) {
            this.destroyWidget(this.props.data);
        }

        if (!compareObjects(nextProps.data, this.props.data)) {
            this.props.glob.AppActions.widgetSave(
                this.props.data.id,
                WidgetData.normalizeForSaveData(nextProps.data, this.props.glob),
                true
            );
        }
    }

    componentWillReceiveProps(nextProps: IWidgetProperties) {
        const compare = compareObjects(nextProps.data, this.props.data);

        if (compare) {
            return;
        }

        const widgetData = WidgetData.getFromObj(nextProps.data, this.props.glob, false);

        this.setState({
            widgetData: widgetData
            // icon: data.widgetData.icon,
            // tabBackColor: data.widgetData.tabBackColor
        });
    }

    componentDidUpdate(prevProps: IWidgetProperties, prevState: IState) {
        if (this.initStarted !== true && this.getContainer() != null) {
            this.initWidget(this.props.data, this.props.options?.printMode, this.props.options?.printLimit);
        }

        if (prevProps.data.type !== this.props.data.type) {
            this.destroyWidget(prevProps.data);
            this.initWidget(this.props.data, this.props.options?.printMode, this.props.options?.printLimit);
        }

        if (prevProps.hidden !== this.props.hidden) {
            this.props.glob.AppActions.widgetSetHidden(
                this.props.tab,
                this.props.workspace,
                this.props.data?.id,
                this.props.hidden
            );
        }

        this.performThemeUpdate(prevProps, prevState);
        this.savedLayoutData = $.extend(true, {}, this.props.layoutData);
    }

    shouldComponentUpdate(nextProps: IWidgetProperties, nextState: IState) {
        const shouldUpdate =
            this.props.data.layout !== nextProps.data.layout ||
            this.props.displayMode !== nextProps.displayMode ||
            this.props.wUnits !== nextProps.wUnits ||
            this.props.hUnits !== nextProps.hUnits ||
            this.props.tab !== nextProps.tab ||
            this.props.mainTab !== nextProps.mainTab ||
            this.props.workspace !== nextProps.workspace ||
            this.props.isWorkspaceSaved !== nextProps.isWorkspaceSaved ||
            this.props.distractFree !== nextProps.distractFree ||
            this.props.workspaceContextId !== nextProps.workspaceContextId ||
            this.props.hidden !== nextProps.hidden ||
            this.props.layoutEdit !== nextProps.layoutEdit ||
            this.state.error !== nextState.error ||
            this.state.widgetData !== nextState.widgetData ||
            !compareObjects(this.savedLayoutData, nextProps.layoutData) ||
            !compareObjects(this.props.style, nextProps.style) ||
            !compareObjects(this.props.namespaces, nextProps.namespaces) ||
            !compareObjects(this.props.data, nextProps.data) ||
            !compareObjects(this.props.theme, nextProps.theme);

        return shouldUpdate;
    }

    handleOnAppStoreChange = (payload) => {
        const action = payload.action;
        const widgetID = this.props.data.id;

        switch (action.actionType) {
            case Constants.WIDGET_CREATE_LINK_CALL_DIALOG:
                if (widgetID === action.widget && this.props.workspace === action.workspace) {
                    getOnCreateLinkHandler(this.props, this.state.widgetData)(null);
                }
                break;

            case Constants.WIDGET_EXPORT_TO_PDF:
                if (
                    this.props.workspace === action.workspace &&
                    this.props.data.values[this.props.data.type].name === action.widget
                ) {
                    this.exportToPDF(action.layout, action.papersize, action.backendMethodConfig);
                }
                break;
        }
    };

    reinitializeWidget = (widget: IWidget, printMode: boolean, printLimit?: number) => {
        this.destroyWidget(widget);
        this.initWidget(widget, printMode, printLimit);
    };

    getOnPrintHandler = (actionType: IActionType, theme: appTheme.IValuesCollection) => {
        return (e) => {
            e.stopPropagation();
            e.preventDefault();

            if (this.pdfLoading) {
                return;
            }

            const showDialog =
                (this.componentRef?.showPDFGenerateDialog &&
                    actionType === IActionType.print &&
                    this.componentRef.showPDFLimit) ||
                actionType !== IActionType.print;
            const showClock = theme['widget-show-clock-pdf'] === true;
            const showTitle = theme['widget-show-title-pdf'] === true;
            const showPages = theme['widget-show-page-pdf'] === true;

            let pageHeader = null;
            let pageFooter = null;
            let coverPage = null;
            let limit = 1000;
            let layout: IPageOrientation;
            let pageSize: string;

            if (theme['print-show-page-header'] === true) {
                pageHeader = theme['print-page-header'];
            }

            if (theme['print-show-page-footer'] === true) {
                pageFooter = theme['print-page-footer'];
            }

            if (theme['print-add-cover-page'] === true) {
                coverPage = theme['print-cover-page-content'];
            }

            let key = this.props.workspace + '_' + this.props.tab + '_' + this.props.data.id;

            if (this.props.data.type === 'pdc-widget-html') {
                const storage =
                    JSON.parse(this.props.glob.AppStore.getFromLocalStorage('HTML_Container_Widget_' + key)) || {};
                pageSize = storage?.pageSize;
                layout = storage?.pageOrientation;
            }

            if (this.props.data.type === 'pdc-widget-cards2') {
                const storage = JSON.parse(this.props.glob.AppStore.getFromLocalStorage('Cards_Widget_' + key)) || {};
                pageSize = storage?.pageSize;
                layout = storage?.pageOrientation;
            }

            const storage = JSON.parse(this.props.glob.AppStore.getFromLocalStorage('print-settings')) || {};

            let title = 'Document Settings';
            let print_settings: any = {};

            if (actionType === IActionType.print) {
                title = 'Print ' + title;

                if (storage) {
                    print_settings = storage.printlimit;
                }
            }

            if (actionType === IActionType.exportToPdf) {
                title = 'PDF ' + title;

                if (storage) {
                    print_settings = storage.pdflimit;
                }
            }

            limit = parseInt(print_settings?.limit) || limit;
            pageSize = pageSize || print_settings?.papersize || 'A4';
            layout = layout || print_settings?.layout || 'p';

            if (showDialog) {
                this.props.glob.DialogActions.createDialog(
                    title,
                    '',
                    (obj) => {
                        let reinitializeWidget = false;
                        let timeout = 0;

                        if (this.componentRef != null) {
                            reinitializeWidget = this.componentRef.reinitializeWidget;

                            if (reinitializeWidget) {
                                this.reinitializeWidget(this.props.data, true, obj.limit);
                            }

                            if (this.componentRef.sqlTimeout > 0) {
                                timeout = this.componentRef.sqlTimeout * 1000;
                            }
                        }

                        const waitGetData = () => {
                            if (this.pdfLoading !== true) {
                                this.pdfLoading = true;

                                const interval = setInterval(() => {
                                    let container;
                                    let printTemplateParams = null;

                                    timeout = timeout - 1000;

                                    if (this.componentRef?.getPrintableArea != null) {
                                        container = this.componentRef.getPrintableArea();
                                    } else {
                                        container = this.getContainer();
                                    }

                                    if (
                                        (this.componentRef != null && $(container).find('.dx-data-row')?.length > 0) ||
                                        timeout < 0
                                    ) {
                                        clearInterval(interval);

                                        if (this.componentRef != null) {
                                            const componentState = this.componentRef.state;

                                            if (componentState != null) {
                                                layout =
                                                    componentState.pageOrientation ||
                                                    componentState.widgetState?.pageOrientation;
                                                pageSize =
                                                    componentState.pageSize || componentState.widgetState?.pageSize;
                                            }

                                            if (this.componentRef.getPrintTemplateParams != null) {
                                                printTemplateParams = this.componentRef.getPrintTemplateParams();
                                            }
                                        }

                                        const widgetValues = this.getWidgetValues();

                                        let name = widgetValues.name;

                                        if (name == null || name.length === 0) {
                                            name = 'report';
                                        }

                                        let pdfOptions: IPDFOptions;

                                        if (actionType === IActionType.print) {
                                            pdfOptions = {
                                                onReady: () => {},
                                                papersize: pageSize || 'A4',
                                                layout: layout || 'p',
                                                showClock: showClock,
                                                showTitle: showTitle,
                                                showPages: showPages,
                                                makeHTMLTableForPrinting: this.componentRef?.makeHTMLTableForPrinting
                                            };
                                        } else {
                                            pdfOptions = {
                                                outputFormat: 'blob',
                                                onReady: (pdf) => {
                                                    saveAs.saveAs(pdf, name + '.pdf');
                                                    //self.initGridWidget(self.props.data, false);
                                                    // self.pdfLoading = false;
                                                },
                                                papersize: obj.papersize,
                                                layout: obj.layout,
                                                showClock: showClock,
                                                showTitle: showTitle,
                                                showPages: showPages,
                                                makeHTMLTableForPrinting: this.componentRef?.makeHTMLTableForPrinting
                                            };
                                        }

                                        printContent(
                                            this.props.glob,
                                            name,
                                            container,
                                            pageHeader,
                                            pageFooter,
                                            coverPage,
                                            printTemplateParams,
                                            actionType,
                                            pdfOptions,
                                            this.props.data.type
                                        );

                                        if (reinitializeWidget) {
                                            this.reinitializeWidget(this.props.data, false);
                                        }

                                        this.pdfLoading = false;
                                    }
                                }, 1000);
                            }
                        };

                        waitGetData();
                        //  self.props.glob.AppActions.setPrintCallback(()=>{ waitGetData() })
                    },
                    () => {
                        this.pdfLoading = false;
                    },
                    () => {
                        this.pdfLoading = false;
                    },
                    'custom',
                    {
                        deny: false,
                        confirmTitle: 'OK',
                        Component: PdfParamDialog,
                        componentOptions: {
                            papersize: pageSize,
                            layout: layout,
                            limit: limit,
                            showLimit: this.componentRef?.showPDFLimit,
                            showPageSize: actionType !== IActionType.print,
                            showLayout: actionType !== IActionType.print,
                            actionType,
                            maxRecords: theme[themeVars.widgetMaxNumberOfRecords]
                        }
                    }
                );
            } else {
                if (this.componentRef != null || this.getContainer() != null) {
                    let container;
                    let printTemplateParams = null;

                    if (this.componentRef?.getPrintableArea != null) {
                        container = this.componentRef.getPrintableArea();
                    } else {
                        container = this.getContainer();
                    }

                    if (container != null) {
                        const widgetValues = this.getWidgetValues();
                        const name = widgetValues.name;

                        printContent(
                            this.props.glob,
                            name,
                            container,
                            pageHeader,
                            pageFooter,
                            coverPage,
                            printTemplateParams,
                            actionType,
                            {
                                onReady: () => {},
                                papersize: pageSize,
                                layout: layout,
                                showClock: showClock,
                                showTitle: showTitle,
                                showPages: showPages
                            },
                            this.props.data.type
                        );
                    }
                }

                this.pdfLoading = false;
            }
        };
    };

    exportToPDF = (
        layout: 'p' | 'portrait' | 'l' | 'landscape',
        papersize: string,
        backendMethodConfig: IBackendMethodConfiguratorValue
    ) => {
        let container;
        let printTemplateParams = null;

        if (typeof this.componentRef.getPrintableArea === 'function') {
            container = this.componentRef.getPrintableArea();
        } else {
            container = this.getContainer();
        }

        if (container != null) {
            const widgetValues = this.getWidgetValues();
            const name = widgetValues.name;
            const theme = this.getTheme();

            let pageHeader = null;
            let pageFooter = null;
            let coverPage = null;
            let showClock;
            let showTitle;
            let showPages;

            if (theme['print-show-page-header'] === true) {
                pageHeader = theme['print-page-header'];
            }
            if (theme['print-show-page-footer'] === true) {
                pageFooter = theme['print-page-footer'];
            }
            if (theme['print-add-cover-page'] === true) {
                coverPage = theme['print-cover-page-content'];
            }
            if (theme['widget-show-clock-pdf'] === true) {
                showClock = theme['widget-show-clock-pdf'];
            }
            if (theme['widget-show-title-pdf'] === true) {
                showTitle = theme['widget-show-title-pdf'];
            }
            if (theme['widget-show-page-pdf'] === true) {
                showPages = theme['widget-show-page-pdf'];
            }
            if (typeof this.componentRef.getPrintTemplateParams === 'function') {
                printTemplateParams = this.componentRef.getPrintTemplateParams();
            }

            const toSendOnBackend = backendMethodConfig != null;

            printContent(
                this.props.glob,
                name,
                container,
                pageHeader,
                pageFooter,
                coverPage,
                printTemplateParams,
                IActionType.exportToPdf,
                {
                    outputFormat: toSendOnBackend ? null : 'blob',
                    onReady: (pdf) => {
                        if (toSendOnBackend) {
                            const methodConfig = backendMethodConfig;
                            const param1: IBackendParameter = {
                                name: 'filename',
                                valueSourceType: 'constant',
                                valueSource: {
                                    constant: name + '.pdf'
                                }
                            };
                            const param2: IBackendParameter = {
                                name: 'content',
                                valueSourceType: 'constant',
                                valueSource: {
                                    constant: btoa(pdf as string)
                                }
                            };

                            methodConfig.parameters.push(param1);
                            methodConfig.parameters.push(param2);

                            const globalState = this.getGlobalState();

                            //EVG: cultureValues is not passed here. It is needed when VARIABLE_FISCAL_MONTH is used. Add it when it is needed here.
                            callBackendMethod(methodConfig, globalState, null, this.props.glob);
                            // this.props.glob.AQLQueries.callMethod('attrQuery_ActionButton', {
                            //     name: backendMethodConfig.name,
                            //     dataSourceID: backendMethodConfig.dataSourceID,
                            //     parameters: {
                            //         filename: name + '.pdf',
                            //         content: btoa(pdf as string)
                            //     }
                            // });
                        } else {
                            saveAs.saveAs(pdf, name + '.pdf');
                        }
                    },
                    papersize: papersize,
                    layout: layout,
                    showClock: showClock,
                    showTitle: showTitle,
                    showPages: showPages
                },
                this.props.data.type
            );
        }
    };

    getOnToggleMenuHandler = (
        platformMenuItems: React.JSX.Element[],
        constr,
        theme: appTheme.IValuesCollection,
        description: string,
        tooltip: string
    ) => {
        return (e) => {
            const offset = $(e.target).offset();
            //EVG: Submenu items, like for Drill Down, are loaded asynchronously and can be not loaded at start.
            // That is why getMenuItems() is called here.
            const menuItems = getMenuItems(
                constr,
                this.state.widgetData,
                theme,
                platformMenuItems,
                description,
                tooltip,
                this.props.distractFree,
                this.props.glob,
                this.getMenuHandler
            );

            finalizeMenuHandler(e);
            showWidgetMenu(menuItems, offset, this.props.glob);
            reactGlobalClick.cancel(2);
        };
    };

    disableLayoutEdit = () => {
        if (typeof this.props.onLayoutModeChange !== 'function') {
            return;
        }

        if (this.props.layoutEdit) {
            this.props.onLayoutModeChange(false);
        }
    };

    handleContainerClick = (e) => {
        if (this.props.layoutEdit) {
            reactGlobalClick.cancel(1);
        }
    };

    handleOnLayoutChange = (value: IWidgetLayout) => {
        this.props.glob.AppActions.widgetSetLayout(
            this.props.workspace,
            this.props.data?.id ?? this.props.data?.cid,
            value
        );
    };

    handleOnConfigFieldSelect = (x: number, y: number) => {
        return (value) => {
            this.props.glob.AppActions.widgetAddField(
                this.props.workspace,
                this.props.data?.id ?? this.props.data?.cid,
                x,
                y,
                value
            );
        };
    };

    handleOnConfigFieldAdd = (x: number, y: number) => {
        this.props.glob.DialogActions.createDialog(
            'Config Field Select',
            '',
            function (e) {},
            function (e) {},
            function (e) {},
            'custom',
            {
                deny: false,
                confirm: false,
                closeTitle: 'Close',

                Component: ConfigFieldSelectComponent_Main,
                componentProps: {
                    data: this.props.data,
                    onSelect: this.handleOnConfigFieldSelect(x, y)
                },

                HeaderComponent: ConfigFieldSelectComponent_Header as any,
                headerComponentProps: {
                    data: this.props.data,
                    onSelect: this.handleOnConfigFieldSelect(x, y)
                },

                getInitialSharedState: function () {
                    return {
                        selected: null
                    };
                }
            }
        );
    };

    getContainers = (content) => {
        const containersNum = this.getCotainersNum();

        return _.map(_.range(containersNum), (i) => {
            return (
                <div
                    key={'widgetCanvas-' + i}
                    className={'widget-canvas widget-canvas-main'}
                    ref={(input) => {
                        this.references.containers[i] = input;
                    }}
                >
                    {i === 0 ? content : null}
                </div>
            );
        });
    };

    getGridLayout = (
        menuFlags: IMenuItemFlags,
        theme: appTheme.IValuesCollection,
        layoutElements: React.JSX.Element[],
        edgeFlags: IEdgeFlags
    ) => {
        const themeFull = appTheme.getThemeObj(theme);

        let width: number;
        let height: number;

        if (this.props.disableSizeMixin) {
            const widgetsMargin = themeFull['workspace-widgets-margin'];
            const bordersWidth = themeFull['widget-border-width'] * 2;
            const widgetPaddings = themeFull['widget-padding'] * 2;

            width =
                (this.props.layoutData?.parentWidth ?? 0) -
                widgetsMargin -
                bordersWidth -
                widgetPaddings +
                (edgeFlags.left ? widgetsMargin / 2 : 0) +
                (edgeFlags.right ? widgetsMargin / 2 : 0);

            const showToolbar = toolbarIsUsed(menuFlags, themeFull);
            const parentHeight = this.props.layoutData?.parentHeight;

            height =
                (parentHeight ?? 0) -
                widgetsMargin -
                bordersWidth -
                widgetPaddings -
                //(themeFull['widget-always-show-header'] || this.props.displayMode === 'widgets') ? WIDGET_TITLE_HEIGHT : 0
                //WorkItem [105178]: All widgets inserted to Nested LAyout widget from Templates  have the wrong height = BUG
                //|| this.props.displayMode === 'widgets' had created by Taras and might be outdated
                //LL: 16.11.23: about "displayMode === 'widgets' might be outdated": (and I suppose it was VR comment) -------------------------
                // No, it is used during Edit WS, see WI 143051:
                //  LL: The problem is in option "Show Widget Header with Title": Header is always shown when WS Editing and takes height approx 24px.
                //  theme['widget-always-show-header']
                //  So, when option "Show Widget Header with Title" is ON, Widget is displayed properly during WS Editing.
                //  If not, Header is added but not considered
                //LL: 16.11.23: So, try to bring back displayMode === 'widgets'
                //LL: and see "showHeader" in render() line 1866
                //LL: maybe it is needed to check that current Widget is not Container-Widget ? Not for now
                // this.props.data.type = "pdc-widget-gauge", chart, calendar - not Containers, but full size
                // Containers: pdc-widget-html, etc
                // -----------------------------------------
                this.getWidgetHeaderHeight(parentHeight, themeFull) -
                (showToolbar ? TOOLBAR_HEIGHT : 0) +
                (edgeFlags.top ? widgetsMargin / 2 : 0) +
                (edgeFlags.bottom ? widgetsMargin / 2 : 0);
        } else if (this.componentRef != null) {
            width = this.componentRef.viewportWidth;
            height = this.componentRef.viewportHeight;
        }

        let result: React.JSX.Element;

        //EVG: width and height can be null on Widget Maximize.
        //if (width != null && height != null) {
        const widget = this.props.data;
        const layoutGeometry = this.getLayout(widget?.layout);
        const containersNum = this.getCotainersNum();

        result = (
            <LayoutGrid
                viewportWidth={width}
                viewportHeight={height}
                layout={layoutGeometry}
                elements={_.map(_.range(containersNum), (i) => {
                    return {};
                }).concat(widget && widget.elements)}
                displayMode={(this.props.layoutEdit && 'widgets') || 'main'}
                showGrid={this.props.layoutEdit}
                dragScope={'widget-' + this.props._key}
                cellAddTitle={'New Config Field'}
                enableResize={true}
                hidden={this.props.hidden}
                workspace={this.props.workspace}
                tab={this.props.tab}
                glob={this.props.glob}
                onLayoutChange={this.handleOnLayoutChange}
                onElementAdd={this.handleOnConfigFieldAdd}
            >
                {layoutElements}
            </LayoutGrid>
        );
        //}

        return result;
    };

    getGridContent = (
        menuFlags: IMenuItemFlags,
        theme: appTheme.IValuesCollection,
        layoutElements: React.JSX.Element[],
        docked: boolean,
        edgeFlags: IEdgeFlags,
        parentHeight: number
    ) => {
        const layout = this.getGridLayout(menuFlags, theme, layoutElements, edgeFlags);

        let style: React.CSSProperties;

        if (!docked) {
            let top: number;

            if (this.props.forceHideHeader) {
                top = 0;
            } else {
                const showToolbar = toolbarIsUsed(menuFlags, theme);

                top = this.getWidgetHeaderHeight(parentHeight, theme) + (showToolbar ? TOOLBAR_HEIGHT : 0);
            }

            if (top != null) {
                style = { top: top + 'px' };
            }
        } else {
            style = { height: '0px', width: '0px' };
        }

        return (
            <div className="widget-canvas" style={style}>
                {layout}
            </div>
        );
    };

    getPlainContent = (layoutElements: React.JSX.Element[]) => {
        return layoutElements;
    };

    //EVG: componentRef is assigned asyncronously and cannot be passed to functions as is.
    componentRefGetter = () => {
        return this.componentRef;
    };

    getMenuHandler = (callback) => {
        return (e) => {
            finalizeMenuHandler(e);

            if (typeof callback !== 'function') {
                return;
            }

            callback(this.props.glob, this.getOptions(this.props.data.type), this.props.data, e);
        };
    };

    render() {
        const { inlineMode } = this.props;
        const edgeFlags = this.props.edgeFlags ?? {};
        const widgetType = this.props.data.type;
        const constr = WidgetBase.getConstructorByName(widgetType);
        const theme = this.getTheme();
        const themeFull = appTheme.getThemeObj(theme);
        const locale = Globalization.getWidgetLocale(theme);

        let content: React.JSX.Element;

        // OE: show progress bar when multiple (~200+) widgets of the same type are loaded
        // this case loading Deferred is waiting for a long time, and UI seems stalled
        if (/*this.state.loading === true*/ theme && theme['widget-show-progress-on-load'] === true) {
            content = <ProgressBar />;
        } else if (this.state.error) {
            content = <em className="error">{'Widget cannot be displayed'}</em>;
        } else if (constr == null) {
            content = (
                <em className="error">{`'${widgetType}' widget is not in included into project. Constructor is not found.`}</em>
            );
        }

        const layoutType = config.LAYOUT_TYPE;
        const widgetValues = this.getWidgetValues();
        const menuFlags = getMenuItemFlags(constr, this.props.distractFree);
        const { docked, parentHeight, parentWidth } = this.props.layoutData ?? {};
        const layoutElements = this.getContainers(content);

        this.addFieldElements(layoutElements);

        let widgetContent: React.JSX.Element | React.JSX.Element[];

        if (this.props.autoSize || inlineMode) {
            widgetContent = this.getPlainContent(layoutElements);
        } else {
            widgetContent = this.getGridContent(menuFlags, theme, layoutElements, docked, edgeFlags, parentHeight);
        }

        const style = _.clone(this.props.style);

        let styleRender = _.clone(style);

        if (styleRender != null) {
            delete styleRender.right;
            delete styleRender.bottom;
        }

        if (this.props.autoSize || inlineMode) {
            if (parentWidth != null) {
                if (styleRender == null) {
                    styleRender = {};
                }

                styleRender.width = parentWidth + (this.props.wUnits != null ? this.props.wUnits : 'px');
            }

            if (parentHeight != null) {
                if (styleRender == null) {
                    styleRender = {};
                }

                styleRender.height = parentHeight + (this.props.hUnits != null ? this.props.hUnits : 'px');
            }
        }

        const platformMenuItems = getPlatformMenuItems(
            this.props,
            this.state.widgetData,
            menuFlags,
            theme,
            locale,
            this.componentRefGetter,
            this.getOnPrintHandler,
            getOnExportToExcelHandler
        );

        const description = widgetValues.description || null;
        const tooltip = widgetValues.tooltip;
        const hideMenuButton = theme[themeVars.hideMenuButtonViewMode] === true;

        let hasMenu = !docked;

        if (hasMenu) {
            //EVG: Here it's only needed to figure out if there are some menu items.
            const menuItems = getMenuItems(
                constr,
                this.state.widgetData,
                theme,
                platformMenuItems,
                description,
                tooltip,
                this.props.distractFree,
                this.props.glob,
                this.getMenuHandler
            );

            hasMenu = menuItems.length > 0;
        }

        let menuToggler: React.JSX.Element;

        if (layoutType !== 'narrow') {
            //LL: 05.08.20: shift MenuButton for container to left, to be able to see internal widget MenuButton:
            //   It is used when Header of container is not shown
            let menuButtonStyle: React.CSSProperties = {};
            let titleMenuButton = '';

            //LL:  NestedLayoutContainer, WorkspaceContainer what other ?  Maybe introduce a flag ?
            //LL:  DrillDown,  Tabbed Widget Container 'pdc-widget-multiple'  - no need
            //LL:  HTML Container  'pdc-widget-html' - ???
            //         Some times is needed, when internal widget is in upper right corner.
            //         But internal widget may be anywhere !!! Can be shifted just by 30px
            let right = 0;

            if (widgetType === 'pdc-widget-layout' || widgetType === 'pdc-widget-workspace') {
                menuButtonStyle = {
                    top: HEADER_BUTTON_WIDTH + 'px',
                    paddingTop: '5px',
                    backgroundColor: '#ccccccc0'
                };

                titleMenuButton = 'Container Menu';
            }

            if (hasMenu && !hideMenuButton) {
                let widgetMenuButton: React.JSX.Element;

                widgetMenuButton = (
                    <WidgetMenuButton
                        style={{ ...menuButtonStyle, right: '0' }}
                        title={titleMenuButton}
                        onClick={this.getOnToggleMenuHandler(platformMenuItems, constr, theme, description, tooltip)}
                    />
                );

                let generatePDF: React.JSX.Element;
                let help: React.JSX.Element;
                let print: React.JSX.Element;
                let excel: React.JSX.Element;

                if (description != null && description !== '') {
                    right = right + HEADER_BUTTON_WIDTH;
                    help = (
                        <HelpHeaderButton
                            style={menuButtonStyle}
                            right={right}
                            title={tooltip}
                            onClick={getOnShowWidgetHelpHandler(description, tooltip, this.props.glob)}
                        />
                    );
                }

                if (menuFlags.exportToExcel) {
                    if (theme[themeVars.widgetShowExportToExcelButton] === true) {
                        right = right + HEADER_BUTTON_WIDTH;
                        excel = (
                            <PrintHeaderButton
                                style={menuButtonStyle}
                                right={right}
                                locale={locale}
                                onClick={getOnExportToExcelHandler(themeFull, this.props, this.componentRefGetter)}
                            />
                        );
                    }
                }

                if (menuFlags.print) {
                    if (theme[themeVars.widgetShowPdfButton] === true) {
                        right = right + HEADER_BUTTON_WIDTH;
                        generatePDF = (
                            <GeneratePDFHeaderButton
                                style={menuButtonStyle}
                                right={right}
                                locale={locale}
                                onClick={this.getOnPrintHandler(IActionType.exportToPdf, theme)}
                            />
                        );
                    }

                    if (theme[themeVars.widgetShowPrintButton] === true) {
                        right = right + HEADER_BUTTON_WIDTH;
                        print = (
                            <PrintHeaderButton
                                style={menuButtonStyle}
                                right={right}
                                locale={locale}
                                onClick={this.getOnPrintHandler(IActionType.print, theme)}
                            />
                        );
                    }
                }

                menuToggler = (
                    <>
                        {help}
                        {print}
                        {generatePDF}
                        {excel}
                        {widgetMenuButton}
                    </>
                );
            }
        }

        let themeComponent: React.JSX.Element;

        // Original Taras's design: Don't apply theme to the widget with inline-mode in HTMLContainer
        // OE 07-02-2020 -- use this behaviour for KPI in inline mode
        if (!(inlineMode && widgetType === 'pdc-widget-kpi')) {
            themeComponent = (
                <ThemeRenderer
                    theme={theme}
                    levels={['widget', widgetType]}
                    context={'#widget-' + this.props._key + '-' + this.props.workspace + '-' + this.props.tab}
                />
            );
        }

        const edittingIsAllowed = permissions.canEdit();
        const editMode = edittingIsAllowed && this.props.displayMode === 'widgets';

        let showHeader = !this.props.forceHideHeader;

        if (showHeader) {
            showHeader =
                editMode || (theme[themeVars.widget_AlwaysShowHeader] === true && parentHeight !== WIDGET_HIDING_SIZE);
        }

        let header: React.JSX.Element;

        if (showHeader) {
            //EVG 04.09.2025:
            // By unknown reason docking vertically may do not work on undocking when handleOnDocking is in WidgetHeader.
            // Like for Filters of 'Issue List' Workspace.
            // Try to fix it again later.
            const handleOnDocking = (e) => {
                if (this.props.onToggleDocking != null) {
                    this.props.onToggleDocking();
                }

                finalizeMenuHandler(e);
            };

            header = (
                <WidgetHeader
                    ref={(input) => {
                        this.references.widgetheader = input;
                    }}
                    workspace={this.props.workspace}
                    tab={this.props.tab}
                    data={this.props.data}
                    widgetValues={widgetValues}
                    menuFlags={menuFlags}
                    layoutType={layoutType}
                    layoutData={this.props.layoutData}
                    layoutEdit={this.props.layoutEdit}
                    edgeFlags={this.props.edgeFlags}
                    constr={constr}
                    editMode={editMode}
                    hasMenu={hasMenu}
                    hideMenuButton={hideMenuButton}
                    locale={locale}
                    theme={theme}
                    glob={this.props.glob}
                    componentRefGetter={this.componentRefGetter}
                    getOnPrintHandler={this.getOnPrintHandler}
                    onClick={handleOnDocking}
                    onExportToExcelClick={getOnExportToExcelHandler(themeFull, this.props, this.componentRefGetter)}
                    onToggleMenu={this.getOnToggleMenuHandler(platformMenuItems, constr, theme, description, tooltip)}
                    onToggleDocking={this.props.onToggleDocking}
                    onLayoutModeChange={this.props.onLayoutModeChange}
                />
            );
        }

        let toolbar: React.JSX.Element;

        if (layoutType !== 'narrow') {
            let showToolbar = !this.props.forceHideHeader && !docked;

            if (showToolbar) {
                showToolbar = toolbarIsUsed(menuFlags, theme);
            }

            if (showToolbar) {
                const btnclass = this.state.loading ? ' disabled' : '';
                const toolbarElements: React.JSX.Element[] = [];

                if (menuFlags.print) {
                    if (theme['widget-show-print'] === true) {
                        toolbarElements.push(
                            <div
                                key="widget-show-print"
                                className={'d-print-none btn btn-default mr-1 mt-1' + btnclass}
                                onClick={this.getOnPrintHandler(IActionType.print, theme)}
                            >
                                <span key="widget-show-print-span" className="fa fa-print">
                                    &nbsp;
                                </span>
                                {Globalization.getMessage('print', locale)}
                            </div>
                        );
                    }

                    if (theme['widget-show-pdf'] === true) {
                        toolbarElements.push(
                            <div
                                key="widget-show-pdf"
                                className={'d-print-none btn btn-default mr-1 mt-1' + btnclass}
                                onClick={this.getOnPrintHandler(IActionType.exportToPdf, theme)}
                            >
                                <span key="widget-show-pdf-span" className="fa fa-file-pdf-o">
                                    &nbsp;
                                </span>
                                {Globalization.getMessage('generatePDF', locale)}
                            </div>
                        );
                    }
                }

                if (menuFlags.exportToExcel) {
                    if (theme['widget-show-export-to-excel'] === true) {
                        toolbarElements.push(
                            <div
                                key="widget-show-export-to-excel"
                                className={'d-print-none btn btn-default mr-1 mt-1' + btnclass}
                                onClick={getOnExportToExcelHandler(theme, this.props, this.componentRefGetter)}
                            >
                                <span key="widget-show-export-to-excel" className="fa fa-file-excel-o">
                                    &nbsp;
                                </span>
                                {Globalization.getMessage('exportToExcel', locale)}
                            </div>
                        );
                    }
                }

                toolbar = (
                    <div
                        className={'mr-5'}
                        ref={(input) => {
                            this.references.widgetToolbar = input;
                        }}
                    >
                        {toolbarElements}
                    </div>
                );
            }
        }

        const widgetInnerContainerStyle: React.CSSProperties = {};

        if (inlineMode) {
            widgetInnerContainerStyle.margin = 0;
        } else {
            if (edgeFlags.top) {
                widgetInnerContainerStyle.marginTop = 0;
            }

            if (edgeFlags.right) {
                widgetInnerContainerStyle.marginRight = 0;
            }

            if (edgeFlags.bottom) {
                widgetInnerContainerStyle.marginBottom = 0;
            }

            if (edgeFlags.left) {
                widgetInnerContainerStyle.marginLeft = 0;
            }
        }

        return (
            <ErrorBoundary>
                <div
                    id={'widget-' + this.props._key + '-' + this.props.workspace + '-' + this.props.tab}
                    ref={(input) => {
                        this.references.container = input;
                    }}
                    className={
                        'widget' +
                        (layoutType === 'narrow' ? ' layout-narrow' : '') +
                        (this.props.layoutEdit ? ' editing-layout' : '') +
                        (this.state.loading ? ' loading' : '') +
                        (edgeFlags.top ? ' edge-top' : '') +
                        (edgeFlags.right ? ' edge-right' : '') +
                        (edgeFlags.bottom ? ' edge-bottom' : '') +
                        (edgeFlags.left ? ' edge-left' : '') +
                        (this.props.autoSize ? ' auto-size' : '') +
                        (inlineMode ? ' inline-mode' : '')
                    }
                    style={styleRender}
                    onClick={this.handleContainerClick}
                >
                    {themeComponent}

                    <div className="widget-inner-container" style={widgetInnerContainerStyle}>
                        {header}

                        <WidgetNotifications runTimeWidgetID={this.state.runTimeWidgetID} glob={this.props.glob} />
                        <WidgetLoadingPanel
                            theme={theme}
                            runTimeWidgetID={this.state.runTimeWidgetID}
                            glob={this.props.glob}
                        />

                        {menuToggler}
                        {toolbar}
                        {widgetContent}
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

function toolbarIsUsed(menuFlags: IMenuItemFlags, theme: IValuesCollection) {
    return (
        (menuFlags.print && theme['widget-show-print']) ||
        (menuFlags.print && theme['widget-show-pdf']) ||
        (menuFlags.exportToExcel && theme['widget-show-export-to-excel'])
    );
}

function getOnExportToExcelHandler(
    theme: IValuesCollection,
    widgetProperties: IWidgetProperties,
    componentRefGetter: () => any
) {
    return (e) => {
        finalizeMenuHandler(e);

        const csvSeparator = getCSVSeparator();
        const componentRef = componentRefGetter();

        let dataLimit = 1000;

        if (typeof componentRef?.getDataLimit === 'function') {
            dataLimit = componentRef.getDataLimit();
        }

        const { data, glob } = widgetProperties;
        const widgetType = data.type;
        const filename = data.values[widgetType].name != null ? data.values[widgetType].name : 'widget-' + data.id;
        const storage = JSON.parse(glob.AppStore.getFromLocalStorage('print-settings')) || {};

        if (storage) {
            let print_settings = storage.excellimit;

            dataLimit = parseInt(print_settings?.limit) || dataLimit;
        }

        const options: IExportToExcelParametersOptions = {
            csvSeparator: csvSeparator,
            limit: dataLimit,
            maxRecords: theme[themeVars.widgetMaxNumberOfRecords],
            widgetType: widgetType,
            filename: filename
        };

        glob.DialogActions.createDialog(
            'Export Data to Excel',
            null,
            (obj) => {
                const def = $.Deferred();

                if (obj.errors.length > 0) {
                    def.reject();
                    return def;
                }

                localStorage['csvSeparator'] = obj.csvFieldSeparator;

                glob.AppActions.widgetExportToExcel(data.id, {
                    format: obj.format,
                    delimiter: obj.csvFieldSeparator,
                    limit: obj.limit,
                    filename: obj.filename
                });

                def.resolve();
                return def;
            },
            () => {},
            () => {},
            'custom',
            {
                deny: false,
                confirmTitle: 'Export',
                componentOptions: options,
                Component: ExportToExcelParameters
            }
        );
    };
}

function WidgetLoadingPanel(props: { theme: appTheme.IValuesCollection; runTimeWidgetID: number; glob: IGlob }) {
    if (props.theme[themeVars.widgetLoadingPanelEnable] === true) {
        return (
            <LoadingPanel
                runTimeWidgetID={props.runTimeWidgetID}
                options={{
                    canCancelQuery: props.theme['widget-loading-panel-cancel-query'],
                    size: props.theme['widget-loading-panel-size']
                }}
                glob={props.glob}
            />
        );
    }

    return null;
}

function HelpHeaderButton(props: { style: React.CSSProperties; right: number; title: string; onClick(e): void }) {
    return (
        <div
            className="show-header-button d-print-none help-header-button"
            style={{
                ...props.style,
                right: props.right + 'px'
            }}
            title={props.title}
            onClick={props.onClick}
        >
            <span className="glyphicon glyphicon-question-sign"></span>
        </div>
    );
}

function PrintHeaderButton(props: { style: React.CSSProperties; right: number; locale: string; onClick(e): void }) {
    return (
        <div
            className="show-header-button d-print-none print-header-button"
            style={{
                ...props.style,
                right: props.right + 'px'
            }}
            title={Globalization.getMessage('print', props.locale)}
            onClick={props.onClick}
        >
            <span className="fa fa-print"></span>
        </div>
    );
}

function GeneratePDFHeaderButton(props: {
    style: React.CSSProperties;
    right: number;
    locale: string;
    onClick(e): void;
}) {
    return (
        <div
            className="show-header-button d-print-none generate-pdf-header-button"
            style={{
                ...props.style,
                right: props.right + 'px'
            }}
            title={Globalization.getMessage('generatePDF', props.locale)}
            onClick={props.onClick}
        >
            <span className="fa fa-file-pdf-o"></span>
        </div>
    );
}

function FieldElement(props: {
    workspace: number;
    id: number;
    widgetData: WidgetData;
    obj: IWidgetFieldElement;
    index: number;
    containersNum: number;
    glob: IGlob;
    onEditComponentChange(widgetData: WidgetData): void;
}) {
    const handleOnFieldRemove = React.useCallback(() => {
        // First indexes are used by containers
        const index = props.index + props.containersNum;

        props.glob.AppActions.widgetRemoveField(props.workspace, props.id, index, index + props.containersNum);
    }, [props.workspace, props.id, props.index, props.containersNum]);

    const getOnEditComponentChangeHandler = (fullValue, fieldName: string, editView) => {
        return (value) => {
            const widgetData = props.widgetData.clone();
            const obj = {};

            obj[fieldName] = editView.output(fullValue, value);
            widgetData.setFieldValues(widgetData.type, obj);

            props.onEditComponentChange(widgetData);

            if (widgetData.widget.isInvalid !== true) {
                props.glob.AppActions.widgetSave(widgetData.id, widgetData.getDataForSave(), false, true);
            } else {
                props.glob.AppActions.showNotification_Fail(
                    'You have selected a value, which invalidates configuration of the widget.' +
                        ' To see more detailed validation report, try to change the same configuration' +
                        ' parameter in widget edit popup.'
                );
            }
        };
    };

    const { widgetData } = props;
    const { widget } = widgetData;
    const obj = props.obj ?? {};
    const fieldName = obj.name;
    const param = widget.parameters[fieldName];

    let editView;

    if (param != null) {
        const editViews = param.collectEditViews(widget.values[fieldName]);

        editView = editViews[obj.view];
    }

    let field: React.JSX.Element;
    let EditComponent;

    if (editView != null) {
        EditComponent = editView.Component;
        field = (
            <ParameterField
                param={param}
                widgetId={widgetData.id}
                widgetType={widgetData.type}
                fieldName={fieldName}
                options={editView.componentOptions || {}}
                title={obj.title || param.title}
                glob={props.glob}
            >
                <EditComponent
                    {...editView.componentProps}
                    title={obj.title || param.title}
                    value={editView.input(widget.values[fieldName])}
                    values={widget.values}
                    param={param}
                    options={editView.componentOptions || {}}
                    glob={param.glob}
                    onChange={getOnEditComponentChangeHandler(widget.values[fieldName], fieldName, editView)}
                />
            </ParameterField>
        );
    }

    return (
        <div className="config-field-container widget-parameters-edit">
            <div className="remove-field-button" onClick={handleOnFieldRemove}>
                <span className="glyphicon glyphicon-remove"></span>
            </div>

            {field}
        </div>
    );
}
